import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { getCookies } from "cookies-next";
import { useCookies } from 'react-cookie';
import axios from "axios";
import { useState } from "react";
import BreadCrump from "../tools/breadcrump"

import * as React from 'react';
import TissEditor from '../Editor/TissEditor';
import ImageUploader from '../tools/uploaderImage';
import { useTranslation } from 'react-i18next';
import HeaderOfPage from '../tools/headerOfPage';
import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import AutoTranslateButton from '../tools/AutoTranslateButton';

type LanguageCode = 'ku' | 'fa' | 'en' | 'ar' | 'tr';

interface MultilingualField {
    ku: string;
    fa: string;
    en: string;
    ar: string;
    tr: string;
    [key: string]: string;
}

export default function EditBlog() {
    const { t } = useTranslation();

    let cookie = getCookies();

    let { Id } = useParams();
    const [cookies, setCookie] = useCookies(['token', 'rule']);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);
    const [activeLang, setActiveLang] = useState<LanguageCode>('en');
    const languages = [
        { code: 'ku' as LanguageCode, label: 'Kurdish' },
        { code: 'fa' as LanguageCode, label: 'فارسی' },
        { code: 'en' as LanguageCode, label: 'English' },
        { code: 'ar' as LanguageCode, label: 'العربية' },
        { code: 'tr' as LanguageCode, label: 'Türkçe' }
    ];

    // Helper function to get display name from multilingual or string
    const getDisplayName = (name: any): string => {
        if (!name) return '';
        if (typeof name === 'string') return name;
        if (typeof name === 'object') {
            return name.en || name.fa || name.ku || name.ar || name.tr || '';
        }
        return String(name);
    };

    const [data, setData] = React.useState<any>(null);
    const [saving, setSaving] = useState<boolean>(false);

    const save = async () => {
        setSaving(true);
        try {
            var path = `${config.url}/v1/dashboard/bloggroup/${Id}`;

            let res = await axios({
                method: 'put',
                data: data,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: t('Group updated successfully'),
                timer: 1500,
                showConfirmButton: false
            });
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t('Error updating group'),
            });
        } finally {
            setSaving(false);
        }
    }
    const load = async () => {
        try {
            var path = `${config.url}/v1/dashboard/bloggroup/${Id}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            const loadedData = res.data.message;
            // Ensure multilingual structure exists
            if (loadedData) {
                if (typeof loadedData.name === 'string') {
                    loadedData.name = { ku: loadedData.name, fa: loadedData.name, en: loadedData.name, ar: loadedData.name, tr: loadedData.name };
                } else if (loadedData.name && loadedData.name.nl) {
                    loadedData.name.ku = loadedData.name.nl;
                    delete loadedData.name.nl;
                    if (!loadedData.name.tr) loadedData.name.tr = '';
                }
                if (typeof loadedData.url === 'string' || !loadedData.url) {
                    loadedData.url = loadedData.url ? { ku: loadedData.url, fa: loadedData.url, en: loadedData.url, ar: loadedData.url, tr: loadedData.url } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.url && loadedData.url.nl) {
                    loadedData.url.ku = loadedData.url.nl;
                    delete loadedData.url.nl;
                    if (!loadedData.url.tr) loadedData.url.tr = '';
                }
                if (typeof loadedData.title === 'string' || !loadedData.title) {
                    loadedData.title = loadedData.title ? { ku: loadedData.title, fa: loadedData.title, en: loadedData.title, ar: loadedData.title, tr: loadedData.title } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.title && loadedData.title.nl) {
                    loadedData.title.ku = loadedData.title.nl;
                    delete loadedData.title.nl;
                    if (!loadedData.title.tr) loadedData.title.tr = '';
                }
                if (typeof loadedData.description === 'string' || !loadedData.description) {
                    loadedData.description = loadedData.description ? { ku: loadedData.description, fa: loadedData.description, en: loadedData.description, ar: loadedData.description, tr: loadedData.description } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.description && loadedData.description.nl) {
                    loadedData.description.ku = loadedData.description.nl;
                    delete loadedData.description.nl;
                    if (!loadedData.description.tr) loadedData.description.tr = '';
                }
                if (typeof loadedData.keywords === 'string' || !loadedData.keywords) {
                    loadedData.keywords = loadedData.keywords ? { ku: loadedData.keywords, fa: loadedData.keywords, en: loadedData.keywords, ar: loadedData.keywords, tr: loadedData.keywords } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.keywords && loadedData.keywords.nl) {
                    loadedData.keywords.ku = loadedData.keywords.nl;
                    delete loadedData.keywords.nl;
                    if (!loadedData.keywords.tr) loadedData.keywords.tr = '';
                }
                if (typeof loadedData.text === 'string' || !loadedData.text) {
                    loadedData.text = loadedData.text ? { ku: loadedData.text, fa: loadedData.text, en: loadedData.text, ar: loadedData.text, tr: loadedData.text } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.text && loadedData.text.nl) {
                    loadedData.text.ku = loadedData.text.nl;
                    delete loadedData.text.nl;
                    if (!loadedData.text.tr) loadedData.text.tr = '';
                }
            }
            setData(loadedData)
        } catch (error) {

        }
    }
    const inputstyle = "py-3 px-5 block w-full border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:pointer-events-none bg-white text-gray-900";
    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Blog',
            url: '/dashboard/Blog'
        },
        {
            name: 'Group List',
            url: '/dashboard/Blog/list'
        },
        {
            name: 'Edit Group',
            url: null
        }
    ]
    useEffect(() => {
        load();
    }, []);

    if (!data) {
        return (
            <div className="bg-gray-50 min-h-screen p-4 md:p-6">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="Edit Category"></HeaderOfPage>
                <div className="bg-white rounded-xl shadow-sm p-8 mt-6">
                    <div className="flex items-center justify-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                    </div>
                    <p className="text-center mt-4 text-gray-600">در حال بارگذاری...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-gray-50 min-h-screen p-4 md:p-6">
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="Edit Category"></HeaderOfPage>

            {data != null && (
                <div className="mt-6">
                    <div className="bg-white rounded-xl shadow-sm overflow-hidden" dir='rtl'>
                        <div className="p-6 space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                {/* Thumbnail */}
                                <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 flex flex-col gap-3">
                                    <div>
                                        <h3 className="text-sm font-semibold text-gray-800 mb-1">
                                            تصویر گروه بلاگ
                                        </h3>
                                        <p className="text-xs text-gray-500">
                                            تصویر شاخص برای نمایش این گروه در صفحات مختلف سایت.
                                        </p>
                                    </div>
                                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 bg-white">
                                        <ImageUploader id={data.id} component={'BlogGroup'}></ImageUploader>
                                    </div>
                                    <div>
                                        <h3 className="text-sm font-semibold text-gray-800 mb-1">
                                            عکس هدر
                                        </h3>
                                        <p className="text-xs text-gray-500">
                                            تصویر هدر برای نمایش در بالای صفحه گروه.
                                        </p>
                                    </div>
                                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 bg-white">
                                        <ImageUploader id={data.id} component={'BlogGroupHeader'}></ImageUploader>
                                    </div>
                                </div>

                                {/* Form */}
                                <div className="md:col-span-2">
                                    <form key={key} className='flex flex-col gap-4'>

                                        {/* Language Selector */}
                                        <div className="mb-4">
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                زبان
                                            </label>
                                            <div className="flex gap-2">
                                                {languages.map((lang) => (
                                                    <button
                                                        key={lang.code}
                                                        type="button"
                                                        onClick={() => setActiveLang(lang.code)}
                                                        className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${activeLang === lang.code
                                                            ? 'bg-blue-600 text-white'
                                                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                                            }`}
                                                    >
                                                        {lang.label}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div>
                                                <div className="flex items-center justify-between mb-1">
                                                    <label className="block text-sm font-medium text-gray-700">
                                                        {t('Name')} ({languages.find(l => l.code === activeLang)?.label})
                                                    </label>
                                                    <AutoTranslateButton
                                                        sourceText={data.name?.en || ''}
                                                        targetLang={activeLang}
                                                        onTranslated={(text) => {
                                                            const slugValue = String(changeUrl(text));
                                                            setData({ ...data, name: { ...data.name, [activeLang]: text }, url: { ...data.url, [activeLang]: slugValue } });
                                                        }}
                                                    />
                                                </div>
                                                <input
                                                    value={data.name?.[activeLang] || ''}
                                                    type="text"
                                                    className={`${inputstyle} ${error != null && error['name'] != undefined && 'bg-red-100 border-red-300'} `}
                                                    placeholder="نام گروه بلاگ را وارد کنید"
                                                    onChange={(e) => {
                                                        const nameValue = e.target.value;
                                                        const slugValue = String(changeUrl(nameValue));
                                                        setData({
                                                            ...data,
                                                            name: {
                                                                ...data.name,
                                                                [activeLang]: nameValue
                                                            },
                                                            url: {
                                                                ...data.url,
                                                                [activeLang]: slugValue
                                                            }
                                                        });
                                                    }}
                                                />
                                                {error != null && error['name'] != undefined && <small className="text-red-500 text-xs mt-1 block">{error['name']['message']}</small>}
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    Code <span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={data.code || ''}
                                                    className={`${inputstyle} ${error != null && error['code'] != undefined && 'bg-red-100 border-red-300'} `}
                                                    placeholder="مثال: CAT001"
                                                    onChange={(e) => setData({ ...data, code: e.target.value })}
                                                />
                                                {error != null && error['code'] != undefined && <small className="text-red-500 text-xs mt-1 block">{error['code']['message']}</small>}
                                                <p className="mt-1 text-xs text-gray-400">
                                                    کد یکتای گروه (به انگلیسی و بدون فاصله).
                                                </p>
                                            </div>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                URL ({languages.find(l => l.code === activeLang)?.label})
                                            </label>
                                            <input
                                                type="text"
                                                value={data.url?.[activeLang] || ''}
                                                className={`${inputstyle} ${error != null && error['url'] != undefined && 'bg-red-100 border-red-300'} `}
                                                placeholder="slug"
                                                onChange={(e) => setData({
                                                    ...data,
                                                    url: {
                                                        ...data.url,
                                                        [activeLang]: e.target.value
                                                    }
                                                })}
                                            />
                                            {error != null && error['url'] != undefined && <small className="text-red-500 text-xs mt-1 block">{error['url']['message']}</small>}
                                        </div>

                                        <div>
                                            <div className="flex items-center justify-between mb-1">
                                                <label className="block text-sm font-medium text-gray-700">
                                                    {t('Keywords')} ({languages.find(l => l.code === activeLang)?.label})
                                                </label>
                                                <AutoTranslateButton
                                                    sourceText={data.keywords?.en || ''}
                                                    targetLang={activeLang}
                                                    onTranslated={(text) => setData({ ...data, keywords: { ...data.keywords, [activeLang]: text } })}
                                                />
                                            </div>
                                            <textarea
                                                value={data.keywords?.[activeLang] || ''}
                                                rows={3}
                                                className={inputstyle}
                                                onChange={(e) => setData({
                                                    ...data,
                                                    keywords: {
                                                        ...data.keywords,
                                                        [activeLang]: e.target.value
                                                    }
                                                })}
                                                placeholder="کلمات کلیدی (با کاما جدا کنید)" />
                                        </div>

                                        <div>
                                            <div className="flex items-center justify-between mb-1">
                                                <label className="block text-sm font-medium text-gray-700">
                                                    {t('Description')} ({languages.find(l => l.code === activeLang)?.label})
                                                </label>
                                                <AutoTranslateButton
                                                    sourceText={data.description?.en || ''}
                                                    targetLang={activeLang}
                                                    onTranslated={(text) => setData({ ...data, description: { ...data.description, [activeLang]: text } })}
                                                />
                                            </div>
                                            <textarea
                                                value={data.description?.[activeLang] || ''}
                                                rows={4}
                                                className={inputstyle}
                                                onChange={(e) => setData({
                                                    ...data,
                                                    description: {
                                                        ...data.description,
                                                        [activeLang]: e.target.value
                                                    }
                                                })}
                                                placeholder="توضیحات گروه" />
                                        </div>

                                        <div className="flex justify-end pt-2">
                                            <button type="button"
                                                onClick={(e) => { save() }}
                                                disabled={saving}
                                                className="inline-flex items-center justify-center gap-x-2 px-6 py-2.5 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none transition-colors"
                                            >
                                                {saving ? (
                                                    <>
                                                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                                        در حال ذخیره...
                                                    </>
                                                ) : (
                                                    <>
                                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                                        </svg>
                                                        {t('Update Category')}
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-6">
                        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                            <TissEditor component='bloggroup' parent={data.id} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}